import React from "react";

function ContactScreen() {
  return <div>ContactScreen</div>;
}

export default ContactScreen;
